(() => {
    const fmt = (cents) => {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      const n = cents / 100;
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0 }).format(n); }
      catch (e) { return '$' + (n % 1 ? n.toFixed(2) : n); }
    };

    const initGallery = (root) => {
      const g = root.querySelector('[data-gallery]');
      if (!g || g.dataset.ready) return;
      g.dataset.ready = '1';
      const track = g.querySelector('[data-gallery-track]');
      const items = Array.from(track.children);
      const btns = Array.from(g.querySelectorAll('[data-gallery-go]'));
      const cur = g.querySelector('[data-gallery-current]');
      const setActive = (i) => {
        btns.forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.galleryGo) === i)));
        if (cur) cur.textContent = i + 1;
      };
      const isCarousel = () => track.scrollWidth > track.clientWidth + 4;
      const go = (i) => {
        const el = items[i];
        if (!el) return;
        if (isCarousel()) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        else el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setActive(i);
      };
      btns.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.galleryGo))));
      track.addEventListener('scroll', () => {
        if (!isCarousel()) return;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(items.length - 1, i)));
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (!isCarousel()) return;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(items.length - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
      });
      root._goToMedia = (mediaId) => {
        const i = items.findIndex((el) => el.dataset.mediaId === String(mediaId));
        if (i > -1 && isCarousel()) go(i);
      };
    };

    const initPicker = (root) => {
      const json = root.querySelector('[data-variant-json]');
      if (!json || root.dataset.pickerReady) return;
      root.dataset.pickerReady = '1';
      let variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      const status = root.querySelector('[data-variant-status]');
      const update = () => {
        const sel = [];
        root.querySelectorAll('[data-option-index]:checked').forEach((i) => { sel[Number(i.dataset.optionIndex)] = i.value; });
        sel.forEach((v, i) => { const l = root.querySelector(`[data-option-label="${i}"]`); if (l) l.textContent = v; });
        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        const forms = [root, document.querySelector('[data-sticky-buy]')].filter(Boolean);
        forms.forEach((scope) => {
          scope.querySelectorAll('[data-variant-input]').forEach((inp) => { if (v) inp.value = v.id; });
          scope.querySelectorAll('[data-add-btn]').forEach((btn) => {
            const ok = v && v.available;
            btn.disabled = !ok;
            btn.innerHTML = ok ? `<span>Add to bag</span><span aria-hidden="true">·</span><span class="gt-mono" data-price>${fmt(v.price)}</span>` : (v ? 'Sold out' : 'Unavailable');
          });
          scope.querySelectorAll('[data-pdp-price] [data-price]').forEach((p) => {
            if (!v || /amazon/i.test(p.textContent)) return;
            p.textContent = fmt(v.price);
            if (v.compare > v.price && !p.closest('.pdp-sticky')) { const sEl = document.createElement('span'); sEl.className = 'gt-price__ref'; sEl.textContent = 'Similar masks ' + fmt(v.compare); p.appendChild(sEl); }
          });
        });
        if (status) status.textContent = v ? `${sel.join(' / ')}, ${v.available ? fmt(v.price) : 'sold out'}` : 'That combination is unavailable';
        if (v) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
          if (v.media && root._goToMedia) root._goToMedia(v.media);
        }
      };
      root.addEventListener('change', (e) => { if (e.target.matches('[data-option-index]')) update(); });
    };

    const init = (scope = document) => scope.querySelectorAll('[data-pdp]').forEach((r) => { initGallery(r); initPicker(r); });
    init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();
